import { Loader2Icon } from 'lucide-react'

/** Full-area loading state: a brand-coloured spinner on a soft ring, with a label for screen readers. */
export function PageLoader({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3" role="status" aria-live="polite">
      <span className="flex size-14 items-center justify-center rounded-full bg-primary/10 ring-8 ring-primary/5">
        <Loader2Icon className="size-6 animate-spin text-primary" />
      </span>
      <span className="text-body-sm text-text-tertiary">{label}</span>
    </div>
  )
}
